import { render, staticRenderFns } from "./ServicePriorityField.vue?vue&type=template&id=2c955cbb"
import script from "./ServicePriorityField.vue?vue&type=script&lang=js"
export * from "./ServicePriorityField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports